<template>
  <component
    :is="componentTag"
    :to="to"
    :href="href"
    :type="nativeType"
    class="btn"
    :class="classes"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'UIButton',
  props: {
    to: { type: String, default: null },
    href: { type: String, default: null },
    variant: { type: String, default: 'primary' }, // primary, outline
    size: { type: String, default: 'md' }, // md, sm
    type: { type: String, default: 'button' }
  },
  computed: {
    componentTag() {
      if (this.to) return 'router-link'
      if (this.href) return 'a'
      return 'button'
    },
    nativeType() {
      return this.to || this.href ? undefined : this.type
    },
    classes() {
      return [
        this.variant === 'outline' ? 'btn-outline' : 'btn-primary',
        this.size === 'sm' ? 'btn-sm' : ''
      ]
    }
  }
}
</script>

<style scoped>
.btn-sm { padding: 8px 14px; font-weight: 600; }
</style>


